// extracted by mini-css-extract-plugin
export default {"syntheticButton":"SyntheticButton_syntheticButton__Wwdc3"};